<script lang="ts">
  import { onMount } from 'svelte';

  export let supportedCountriesAndLangs: Record<string, any>;

  let currentPath: string = '';

  onMount(() => {
    currentPath = window.location.pathname;
  });
</script>

<div class="AvailableLocalesPartial">
  <!-- The keys of the supportedCountriesAndLangs object (country name) sorted alphabetically -->
  {#each Object.keys(supportedCountriesAndLangs).sort() as countryName}
    <ul>
      <!-- An array of country names as well as supported languages and locales in JSON format-->
      {#each supportedCountriesAndLangs[countryName] as option}
        <!-- https://regexr.com/7ab78 -->
        <!-- squareup.com/us/en => squareup.com/ca/en?country_redirection=true -->
        <li>
          <a
            href="{currentPath.replace(
              /\/\w+\/\w+/,
              `/${option.countryTwoLetterCode.toLowerCase()}/${option.langTwoLetterCode}`
            )}?country_redirection=true"
          >
            {option.countryLocalizedFullName} ({option.langLocalizedFullName})
          </a>
        </li>
      {/each}
    </ul>
  {/each}
</div>

<style lang="scss">
  @layer standard-components {
    ul {
      margin: var(--space-none);
      padding-bottom: var(--space-20);
      padding-top: var(--space-20);
      border-bottom: 1px solid var(--color-gray-15);
    }

    ul li {
      padding-left: 0;
    }

    ul li a {
      font-size: var(--font-size-body);
    }
  }
</style>
